<button mat-icon-button (click)="noReportsInfo()">
        <mat-icon s26-skeleton--icon>info</mat-icon>
</button>
